import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{

  },
  content: {
    padding: '20px'
  },
  emptyContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '192px',
    borderRadius: '12px',
    background: theme.palette.primary.primary50,
    cursor: 'pointer',
    '&:hover': {
      background: theme.palette.primary.primary100
    },
    '&:active': {
      background: theme.palette.primary.primary200
    }
  },
  emptyContentTitle: {
    color: theme.palette.primary.primary800,
    fontSize: '16px',
    fontWeight: 600
  },
}));

export default useStyles;
